import React from 'react';


import { CSSTransition } from 'react-transition-group';
import { range } from 'lodash-es';
import LoadingLogo from './common/LoadingLogo'

import { history } from '../history'

import {
  AppleSvg,
  AndroidSvg,
  NeuroFitNamedLogoSvg,
  InstagramSvg,
  LinkedInSvg,
} from '../constants/svgs'

import {
  subdomainUrls,
  recordLinkClickGA,
  ProductionAboutAndrewBaseUrl,
  NeuroFitUniversalAppStoreLink,
  NeuroFitAppleAppStoreLink,
  NeuroFitGooglePlayStoreLink,
  NeuroFitInstagramLink,
  NeuroFitLinkedInLink,
  AndrewInstagramLink,
  AndrewLinkedInLink,
  recordLinkClickAndRedirect,
  BlogSomaticExercisesWeightLossUrl,
  BlogSomaticExercisesTraumaUrl,
  BlogSomaticExercisesSleepUrl,
  BlogSomaticExercisesAngerUrl,
  BlogDorsalVagalRegulationUrl,
  BlogNervousSystemCoachUrl,
  ProductionLegalTermsOfServiceUrl,
  ProductionLegalPrivacyPolicyUrl,
  getCurrentYear,
} from '../utils'

import {
  GA_LABEL_CLICKED_APP_DOWNLOAD_LINK,
} from '../constants/gaEventLabels'

import QrCodeDownloadModal from './modals/QrCodeDownloadModal'
import DownloadButtonsSection from './common/DownloadButtonsSection'
import WebsiteFooterSection from './common/WebsiteFooterSection'

import Helmet from './common/Helmet'

const containerStyle = {textAlign: "start", height: "100%", width: "100vw", overflowX: "hidden", overflowY: "scroll"}


class AndrewAuthorPage extends React.Component {
  constructor(props){
     super(props)
     this.state = {
        learnMoreRef: React.createRef(),
        headerColor: "transparent",
        dropShadowColor: "transparent",
        show: true,
        showIframe: false,
        showQrCodeModal: false
     }
  }

  handleOnClickLearnMore = (event) => {
      //.current is verification that your element has rendered
      if(this.state.learnMoreRef.current){
          this.state.learnMoreRef.current.scrollIntoView({ 
             behavior: "smooth", 
             block: "nearest"
          })
      }
  }

  updateHeaderColorOnContainerScroll = e => {
    if (e.target.scrollTop > 0) {
      const alpha = Math.min(0.5, e.target.scrollTop / 500)
      const headerColor = `rgba(255, 255, 255, ${alpha/1.5})`
      const dropShadowColor = `rgba(0, 0, 0, ${alpha/3.0})`
      this.setState({headerColor, dropShadowColor/* `rgba(53, 63, 106, ${alpha}`*/})
    } else {
      this.setState({headerColor: "transparent", dropShadowColor: "transparent"})
    }

    if (e.target.scrollTop > 400) {
      this.setState({showIframe: true})
    }
  }

  componentDidMount() {
    this.setState({show: true})
    this.scrollingContainerRef.addEventListener('scroll', this.updateHeaderColorOnContainerScroll)
  }

  render() {

    const {
      safeAreaInsets,
      innerHeight,
      formFields,
      isNative,
      isIOSDevice,
      isAndroidDevice,
    } = this.props

    const {show, learnMoreRef, scrollingContainerRef, headerColor, dropShadowColor, showQrCodeModal, showIframe} = this.state

    const currentYear = getCurrentYear()

    const appDownloadUrl = isIOSDevice ? NeuroFitAppleAppStoreLink : (isAndroidDevice ? NeuroFitGooglePlayStoreLink : NeuroFitUniversalAppStoreLink)

    return (
      <div style={{height: innerHeight}}>
        <Helmet
          title={"About Andrew Hogue - Co-CEO NEUROFIT"}
          description={"Andrew Hogue is the Co-CEO of NEUROFIT - a leading nervous system tech company revolutionizing global stress and burnout relief."}
          href={ProductionAboutAndrewBaseUrl}
        />
        <div style={{position: "fixed", left: 0, top: 0, height: innerHeight, overflow: "hidden", backgroundColor: "#EDEEF2"}}>
          <div style={{position: "fixed", top: 0, left: 0, right: 0, height: safeAreaInsets.top, backgroundColor: "#000000", zIndex: 2000}} />
          <div style={{position: "fixed", top: 0, left: 0, right: 0, boxShadow: "0px 2px 0px 0px black", display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: 12 + safeAreaInsets.top, paddingInlineStart: "min(40px, 7.5%)", paddingInlineEnd: "min(20px, 4%)", paddingBottom: 12, backgroundColor: "white", zIndex: 1000}}>
            <NeuroFitNamedLogoSvg
              logoSize={"min(4.25vw, 18px)"}
              color={"#000000"}
              onClick={() => window.location = "/"}
            />
            {!isNative && (
              <div style={{display: "flex", alignItems: "center"}}>
                <a
                  href={"/"}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{fontFamily: "Futura Medium", textDecoration: "none", fontSize: "min(4vw, 15px)", textTransform: "uppercase", color: "#000000", cursor: "pointer"}}
                >
                  {"Home"}
                </a>
              </div>
            )}
          </div>
          <div 
            id={"landing-page-container"}
            className={"disable-scrollbars"}
            ref={elem => this.scrollingContainerRef = elem}
            style={containerStyle}
          >
            <div style={{textAlign: "start", width: "100vw", minHeight: innerHeight}}>
              <div style={{color: "black", width: "100%", display: "flex", justifyContent: "center", alignItems: "top", margin: "calc(60px + 3vh) 0px"}}>
                <div style={{width: "85%", maxWidth: 700}}>
                  <h1 style={{fontSize: "min(8.5vw, 40px)", margin: 0, textTransform: "uppercase", textAlign: "start", fontFamily: "Futura"}}>
                    {"Andrew Hogue"}
                  </h1>
                  <h2 style={{fontSize: "min(7vw, 32px)", margin: 0, textTransform: "uppercase", textAlign: "start", fontFamily: "Futura"}}>
                    {"Co-CEO NEUROFIT"}
                  </h2>
                  <h2 style={{fontSize: "min(6vw, 26px)", margin: 0, textTransform: "uppercase", textAlign: "start", fontFamily: "Futura"}}>
                    {"Research, Product, Tech"}
                  </h2>
                  <div style={{color: "black",  margin: "2vh 0px", width: "100%", display: "flex", justifyContent: "left", alignItems: "center"}}>
                    <img src="/images/founders/andrew.jpg" class="author-profile-image" />
                    <a
                      itemprop="sameAs"
                      href={AndrewInstagramLink}
                      rel="noreferrer noopener"
                      target="_blank"
                      style={{marginInlineStart: "min(6vw, 26px)", backgroundColor: "#CFD2DD", cursor: "pointer", borderRadius: "5px", height: "min(9vw, 45px)", width: "min(9vw, 45px)", display: "flex", justifyContent: "center", alignItems: "center"}}
                    >
                      <InstagramSvg
                        color={"#7c7e84"}
                        size={"min(5vw, 22px)"}
                      />
                    </a>
                    <a
                      itemprop="sameAs"
                      href={AndrewLinkedInLink}
                      rel="noreferrer noopener"
                      target="_blank"
                      style={{marginInlineStart: "min(6vw, 26px)", backgroundColor: "#CFD2DD", cursor: "pointer", borderRadius: "5px", height: "min(9vw, 45px)", width: "min(9vw, 45px)", display: "flex", justifyContent: "center", alignItems: "center"}}
                    >
                      <LinkedInSvg
                        color={"#7c7e84"}
                        size={"min(5vw, 22px)"}
                      />
                    </a>
                  </div>
                  <div style={{fontFamily: "Futura Book", marginTop: "2vh", fontSize: "min(5.5vw, 22px)"}}>
                    {"Andrew Hogue is the Co-CEO and Head of Research & Development, Product, & Tech at NEUROFIT, a leading wellness tech company revolutionizing stress and burnout relief with nervous system regulation."}
                  </div>
                  <div style={{fontFamily: "Futura Book", marginTop: "2vh", fontSize: "min(5.5vw, 22px)"}}>
                    {"With a background in Computer Science from the California Institute of Technology, Andrew has spent over 10 years creating innovative tech products to enhance human well-being."}
                  </div>
                  <div style={{fontFamily: "Futura Book", marginTop: "2vh", fontSize: "min(5.5vw, 22px)"}}>
                    {"Before co-founding NEUROFIT, Andrew focused on meditation recommendations at Headspace and consulted on wellness tech product design and research for the Yale Center for Emotional Intelligence. His global-scale products have reached millions of users worldwide, earning organic features from the BBC, Wired, Forbes, Well+Good, SHAPE, Prevention, Men's Health, Real Simple, Business Insider and Medical News Today."}
                  </div>
                  <div style={{fontFamily: "Futura Book", marginTop: "2vh", fontSize: "min(5.5vw, 22px)"}}>
                    {"Having grown up in a family navigating autism, bipolar disorder, anxiety, and depression, Andrew experienced Complex PTSD firsthand for multiple decades. This profound personal journey, combined with his work at the intersection of technology and emotional health, ignited his passion for developing accessible solutions for mental and physical wellbeing."}
                  </div>
                  <div style={{fontFamily: "Futura Book", marginTop: "2vh", fontSize: "min(5.5vw, 22px)"}}>
                    {"Driven by these experiences and a mission to support others, Andrew co-founded NEUROFIT alongside his wife, Loren. Together, they designed the NEUROFIT app to make stress and burnout relief globally accessible through evidence-based nervous system regulation. Their approach has led to remarkable results, with the average active member reporting a 54% decrease in stress levels after just one week."}
                  </div>
                  <div style={{fontFamily: "Futura Book", marginTop: "2vh", fontSize: "min(5.5vw, 22px)"}}>
                    {"Download the NEUROFIT App here:"}
                  </div>
                  {(isIOSDevice || isAndroidDevice) ? (
                    <div style={{display: "flex", justifyContent: "center"}}>
                      <button
                        style={{display: "flex", alignItems: "top", justifyContent: "center", width: "100%", maxWidth: 400, textAlign: "center", fontFamily: "Futura", fontSize: "min(6vw, 25px)", lineHeight: "min(6vw, 25px)", marginTop: 32, color: "#ffffff", backgroundColor: "#000000", padding: "18px 15px", border: "none"}}
                        onClick={() => {
                          recordLinkClickGA("Universal App Download Link")
                          window.open(NeuroFitUniversalAppStoreLink, "_blank", "noopener noreferrer nofollow")
                        }}
                      >
                        {isIOSDevice ? (
                          <AppleSvg />
                        ) : (isAndroidDevice ? (
                          <AndroidSvg />
                        ) : null)}
                        <span>
                          {"DOWNLOAD NOW"}
                        </span>
                      </button>
                    </div>
                  ) : (
                    <div>
                      <div style={{display: "flex", justifyContent: "center"}}>
                        <button
                          style={{display: "flex", alignItems: "top", justifyContent: "center", width: "100%", maxWidth: 400, textAlign: "center", fontFamily: "Futura", fontSize: "min(6vw, 25px)", lineHeight: "min(6vw, 25px)", marginTop: 32, color: "#ffffff", backgroundColor: "#000000", padding: "18px 15px", border: "none"}}
                          onClick={() => {
                            recordLinkClickGA("Universal App Download Link")
                            window.open(NeuroFitAppleAppStoreLink, "_blank", "noopener noreferrer nofollow")
                          }}
                        >
                          <AppleSvg />
                          <span>
                            {"DOWNLOAD IOS"}
                          </span>
                        </button>
                      </div>
                      <div style={{display: "flex", justifyContent: "center"}}>
                        <button
                          style={{display: "flex", alignItems: "top", justifyContent: "center", width: "100%", maxWidth: 400, textAlign: "center", fontFamily: "Futura", fontSize: "min(6vw, 25px)", lineHeight: "min(6vw, 25px)", marginTop: 32, color: "#ffffff", backgroundColor: "#000000", padding: "18px 15px", border: "none"}}
                          onClick={() => {
                            recordLinkClickGA("Universal App Download Link")
                            window.open(NeuroFitGooglePlayStoreLink, "_blank", "noopener noreferrer nofollow")
                          }}
                        >
                          <AndroidSvg />
                          <span>
                            {"DOWNLOAD ANDROID"}
                          </span>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <WebsiteFooterSection
              safeAreaInsets={safeAreaInsets}
              onOpenAppQrCodeModal={() => this.setState({showQrCodeModal: true})}
              showFoundersSection
            />
          </div>
          <QrCodeDownloadModal
            show={showQrCodeModal}
            onHide={() => this.setState({showQrCodeModal: false})}
            safeAreaInsets={safeAreaInsets}
          />
        </div>
      </div>
    )
  }
}

export default AndrewAuthorPage;